import { MenuAiItemChange } from '../../../types/api/menuAi.types';

/**
 * Change-type badge labels for an item in the Changes panel. Also the single
 * source of truth for "did the AI touch this item" — an empty list means the
 * row is noise and should be hidden (and not offered a Revert affordance).
 * Backend semantics: `categoryRenamed` wins over `movedCategory`.
 */
export const itemChangeBadges = (c: MenuAiItemChange): string[] => {
  const badges: string[] = [];
  if (c.nameChanged) badges.push('Name');
  if (c.priceChanged) badges.push('Price');
  if (c.categoryRenamed) badges.push('Category renamed');
  else if (c.movedCategory) badges.push('Moved');
  if (c.orderChanged) badges.push('Reordered');
  if (c.descriptionChanged) badges.push('Description');
  // Empty `oldPrepNotes` → the item had none, so the AI added them.
  if (c.prepNotesChanged)
    badges.push(c.oldPrepNotes ? 'Prep notes' : 'Prep notes added');
  if (c.imageChanged) badges.push('Image');
  if (c.modifiersChanged || (c.modifiers?.length ?? 0) > 0)
    badges.push('Modifiers');
  return badges;
};

export const hasItemChange = (c: MenuAiItemChange) =>
  itemChangeBadges(c).length > 0;
